export class FormFile {
  controls;
  constructor() {}

  init() {
    this.controls = document.querySelectorAll('.footer-form-file-control');
    if (!this.controls) return;

    this.controls.forEach((el) => {
      const name = el.parentNode.querySelector('.footer-form-file-name');

      el.addEventListener('change', () => {
        if (el.value) {
          name.textContent = el.value.split('\\').pop().split('/').pop();
          el.classList.add('filled');
        } else {
          name.textContent = '';
          el.classList.remove('filled');
        }
      });
    });
  }
}
